import { Controller } from "@hotwired/stimulus"

// Drives the timecard detail screen's snooze flyout: a trigger button opens a
// menu of preset durations (each a button_to that POSTs the snooze endpoint)
// plus a custom date entry revealed on demand. Mirrors the table popup's snooze
// submenu, but standalone — the detail screen has no selection_controller.
// Closes on outside click or Escape.
export default class extends Controller {
  static targets = ["menu", "custom", "customInput"]

  connect() {
    this.onDocClick = this.onDocClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener("click", this.onDocClick)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocClick)
    document.removeEventListener("keydown", this.onKeydown)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.menuTarget.hidden = false
    this.setExpanded(true)
  }

  close() {
    this.menuTarget.hidden = true
    if (this.hasCustomTarget) this.customTarget.hidden = true
    this.setExpanded(false)
  }

  revealCustom(event) {
    event.stopPropagation()
    if (!this.hasCustomTarget) return
    this.customTarget.hidden = false
    if (this.hasCustomInputTarget) this.customInputTarget.focus()
  }

  setExpanded(open) {
    const trigger = this.element.querySelector("[aria-haspopup]")
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false")
  }

  onDocClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
